<script>
    import {ROUTE_TYPE} from "../lib/js/constants.js";
    import {addToDate, YMD} from "../lib/js/utils.js";
    import Icon from "../lib/components/icons/Icon.svelte";
    import OfferTransferRoute from "./OfferTransferRoute.svelte";
    import OfferTourRoute from "./OfferTourRoute.svelte";
    import ReservationPassengers from "../book/ReservationPassengers.svelte";

    export let offer;
    export let reservation;
    export let onNext = () => {
    };

    let startDate = '';
    let initialized = false;

    const onRouteChange = ({detail}) => {

        if (detail.index > 0) {
            return;
        }

        // automatically change route locations
        const location = detail.location;

        reservation.routes.map(route => {
            // check if route has pickup location
            if (!route.pickup_manually_selected) {
                // check if location exist in pickups
                if (route._pickups.some((x) => x.id === location.id)) {
                    route._pickup = location;
                }
            }
            if (!route.drop_manually_selected) {
                // check if location exist in destinations
                if (route._destinations.some((x) => x.id === location.id)) {
                    route._drop = location;
                }
            }
        });
    }

    const initialize = () => {
        const start_day = addToDate(new Date(), 1);
        startDate = YMD(start_day);

        initialized = true;
    }

    const submit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (reservation.children == 0) {
            reservation.baby_seats = 0;
            reservation.boosters = 0;
        }
        if (reservation.infants == 0) {
            reservation.infant_seats = 0;
        }

        onNext();
    }

    initialize();

    $: reservation.passengers = reservation.adults + reservation.children + reservation.infants;

    $: if (reservation.infants > reservation.infant_seats) {
        reservation.infant_seats = reservation.infants;
    }
</script>

{#if initialized}
    <div class="section-title mb-4">
        <h2 class="h4 mb-0">{offer.title}</h2>
        <div>Please provide your pickup details below</div>
    </div>

    <form autocomplete="off" on:submit={submit}>
        <div class="mb-4">
            {#each reservation.routes as route, index}
                <div class="mb-4">
                    {#if route.route_type != ROUTE_TYPE.TOUR}
                        <div class="fw-semibold mb-2">{route.title}</div>
                        <OfferTransferRoute bind:route={route} {startDate} {index} on:change={onRouteChange}/>
                    {:else}
                        <div class="fw-semibold mb-2">Tour: {route.title}</div>
                        <OfferTourRoute bind:route={route} {startDate} {index} on:change={onRouteChange}/>
                    {/if}
                </div>
            {/each}

            <div class="fw-semibold mb-2">Passengers</div>
            <ReservationPassengers bind:reservation/>
        </div>

        <!--  Check if passengers exceed vehicle limit-->
        {#if reservation.vehicle && reservation.passengers > reservation.vehicle.max_pax}
            <div class="alert alert-danger">
                The number of passengers you selected exceeds the passenger limit of the vehicle you selected!
            </div>
        {/if}

        <p class="mb-4">All transfers are private and include complimentary bottled water and Wi-Fi.</p>

        <div class="row">
            <div class="col-lg-3 col-md-3 col-6">
<!--                <button type="button"-->
<!--                        class="btn btn-secondary d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3"-->
<!--                        on:click={onBack}>-->
<!--                    <span class="btn-icon"><Icon name="chevron-left" size="16"/></span>-->
<!--                    Back-->
<!--                </button>-->
            </div>
            <div class="col-lg-6 col-md-4 hidden-sm hidden-xs"></div>
            <div class="col-lg-3 col-md-5 col-6">
                <button type="submit"
                        class="btn btn-primary d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3">
                <span class="hidden-xs hidden-sm">
                    Continue to Personal Info
                </span>
                    <span class="hidden-md hidden-lg hidden-xl">
                    Continue
                </span>
                    <span class="btn-icon"><Icon name="chevron-right" size="16"/></span>
                </button>
            </div>
        </div>
    </form>
{/if}

<style>
    .control-tip {
        font-size: 13px;
        color: #6d6d6d;
        background: #f7f7f7;
        border-radius: 3px;
        margin-top: 1px;
    }
</style>